// DEPRECATED. Please import from constants/FeatureTypes.
export * from '@disco/constants/FeatureTypes'

/** Plus plan identifier for 2020 pricing structure. */
export const PLUS_ID = '2020-plus'

/** Pro plan identifier for 2020 pricing structure. */
export const PRO_ID = '2020-pro'

/** Enterprise plan identifier for 2020 pricing structure. */
export const ENTERPRISE_ID = '2020-enterprise'

/** Artist plan identifier introduced in 2023. */
export const ARTIST_ID = '2023-artist'

export type PlanId =
  | '2020-lite'
  | '2020-plus'
  | '2020-pro'
  | '2020-enterprise'
  | '2023-artist'
